import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { DeliveryNotePartiesState } from './delivery-note-parties.state';
import { DeliveryNotePartiesInitialState, DeliveryNotePartiesLoad } from './delivery-note-parties.actions';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common';
import { DeliveryNoteParams, DeliveryNotePartiesModel } from '../../models';

@Injectable({ providedIn: 'root' })
export class DeliveryNotePartiesFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(DeliveryNotePartiesState.getLoaded);
  parties$: Observable<DeliveryNotePartiesModel[]> = this.store.select(DeliveryNotePartiesState.getParties);

  constructor(private store: Store) {}
  loadAll(params: DeliveryNoteParams): void {
    this.loadParties(params);
  }

  setInitialState(): void {
    this.store.dispatch(new DeliveryNotePartiesInitialState());
  }

  private loadParties(params: DeliveryNoteParams): void {
    this.store.dispatch(new DeliveryNotePartiesLoad(params));
  }
}
